import { useSelector } from 'react-redux';
import { getCurrencySymbol } from '../../../../client/Juno/helpers';
import PropTypes from 'prop-types';
import CopyButton from '../../common/CopyButton';

const SendReview = ({ selectedCrypto, amount, balancesCrypto }) => {
    const { selected, selectedBlockain, selectedToAddress, selectedToAddressName } = selectedCrypto;

    const { currencyShortName } = selected;

    const { total } = amount;
    const imageBaseURl = useSelector(state => state.config.image_base_url);
    const balance = balancesCrypto.find(balance => balance.currencyShortName == currencyShortName);

    return (
        <div className="flex flex-col gap-6">
            <div className="self-stretch flex flex-col justify-start items-start gap-9">
                <div className="self-stretch flex flex-col justify-center items-start gap-3">
                    <div className="self-stretch justify-start">
                        <span class="text-textGray text-sm font-normal uppercase leading-tight">
                            Are you sure you want to send{' '}
                        </span>
                        <span class="!text-text text-sm font-semibold uppercase leading-tight">
                            {total} ({currencyShortName})
                        </span>
                        <span class="text-textGray text-sm font-normal uppercase leading-tight">
                            {' '}
                            to this address? This is a permanent action and cannot be undone once
                            confirmed.{' '}
                        </span>
                    </div>
                    <div className="self-stretch justify-start text-textGray text-sm font-normal uppercase leading-tight">
                        Please double check the address in full and confirm to continue.
                    </div>
                </div>
                <div className="self-stretch flex flex-col justify-start items-start gap-6">
                    <div className="self-stretch flex flex-col justify-start items-start gap-2">
                        <div className="self-stretch inline-flex justify-start items-center gap-2">
                            <div className="flex-1 justify-center !text-textGray text-[#51525C] text-xs font-medium uppercase leading-none">
                                Send
                            </div>
                        </div>
                        <div className="self-stretch p-3 bg-[#FAFAFA] rounded-md outline outline-1 outline-offset-[-1px] outline-[#d3d3d7] dark:outline-[#51525C] flex flex-col justify-center items-start gap-2 overflow-hidden dark:bg-[#ffffff0a]">
                            <div className="self-stretch h-7 inline-flex justify-start items-center gap-2">
                                <div className="flex-1 flex justify-start items-center gap-1">
                                    {selected?.currencyIcon ? (
                                        <img
                                            src={`${imageBaseURl}${selected?.currencyIcon}`}
                                            alt="flag"
                                            className="w-5 h-5 rounded-full"
                                        />
                                    ) : null}{' '}
                                    <div className="flex-1 justify-center dark:!text-text text-base font-medium uppercase leading-normal">
                                        {selectedBlockain}
                                    </div>
                                    <div className="text-right justify-center text-text text-xl font-medium uppercase">
                                        {getCurrencySymbol(currencyShortName)} {total} (
                                        {currencyShortName})
                                    </div>
                                </div>
                            </div>
                            <div className="self-stretch h-[0.2px] relative bg-[#d3d3d7] mt-[2px] mb-[4px]" />
                            <div className="w-full mt-2 flex justify-between items-center gap-1">
                                <div className="flex-1 justify-center !text-textGray text-[#51525C] text-xs font-medium uppercase leading-none">
                                    BALANCE:
                                </div>
                                <div className="text-right text-text text-xs font-medium uppercase leading-none">
                                    {getCurrencySymbol(currencyShortName)}{' '}
                                    {balance?.balanceAmount || 0} ({currencyShortName})
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="self-stretch flex flex-col justify-start items-start gap-2 ">
                        <div className="self-stretch inline-flex justify-start items-center gap-2">
                            <div className="flex-1 justify-center text-textGray text-[#51525C] text-xs font-medium uppercase leading-none">
                                Blockchain Details
                            </div>
                        </div>
                        <div className="self-stretch p-3 bg-[#FAFAFA] rounded-md outline outline-1 outline-offset-[-1px] dark:bg-[#ffffff0a] outline-[#d3d3d7] dark:outline-[#51525C] flex flex-col justify-center items-start gap-2 overflow-hidden">
                            <div className="self-stretch inline-flex justify-between items-center">
                                <div className="flex-1 justify-center text-textGray text-[#51525C] text-xs font-medium uppercase leading-none">
                                    Blockchain:
                                </div>
                                <div className="text-right justify-center text-textGray text-text text-xs font-medium uppercase leading-none">
                                    {selectedBlockain}
                                </div>
                            </div>
                            <div className="self-stretch h-[0.2px] relative bg-[#d3d3d7] mt-[2px] mb-[4px]" />
                            <div className="self-stretch inline-flex justify-between items-center">
                                <div className="flex-1 justify-center text-textGray text-[#51525C] text-xs font-medium uppercase leading-none">
                                    Name address:
                                </div>
                                <div className="flex-1 text-right justify-center text-textGray text-text text-xs font-medium uppercase leading-none">
                                    {selectedToAddressName}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="self-stretch flex flex-col justify-start items-start gap-2">
                        <div className="self-stretch inline-flex justify-start items-center gap-2">
                            <div className="flex-1 justify-center text-textGray  text-[#51525C] text-xs font-medium uppercase leading-none">
                                Recipient address
                            </div>
                        </div>
                        <div className="self-stretch p-3 bg-[#FAFAFA] rounded-md outline outline-1 outline-offset-[-1px] outline-[#d3d3d7] dark:outline-divider-text flex flex-col justify-center items-start gap-2 overflow-hidden dark:bg-[#ffffff0a]">
                            <div className="self-stretch h-12 pl-4 pr-3 bg-[#FAFAFA] rounded-lg outline outline-1 outline-offset-[-1px] outline-[#d3d3d7] dark:outline-[#51525C] inline-flex justify-start items-center gap-2 dark:bg-[#26272B]">
                                <div className="flex-1 justify-center text-text text-sm font-medium leading-tight overflow-hidden">
                                    {selectedToAddress}
                                </div>
                                <CopyButton copyValue={selectedToAddress} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

SendReview.propTypes = {
    selectedCrypto: PropTypes.shape({
        selected: PropTypes.shape({
            currencyShortName: PropTypes.string,
            currencyIcon: PropTypes.string,
        }),
        selectedBlockain: PropTypes.string,
        selectedToAddress: PropTypes.string,
        selectedToAddressName: PropTypes.string,
    }),
    amount: PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    balancesCrypto: PropTypes.arrayOf(
        PropTypes.shape({
            currencyShortName: PropTypes.string.isRequired,
            balanceAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
    ).isRequired,
};

export default SendReview;
